<template>
    <div class="net-average">
        <div class="d-flex flex-column">
            <template v-for="r in list" :key="r">
                <span class="fixed-value left fs-6 b-500 text-default">{{ r.name }}</span>
                <div class="progress-container" :class="[ r.css ]">
                    <div class="timeline"></div>
                    <span class="back-circle"></span>
                    <div class="progress-bar">
                        <div class="progress" :style="{ 'width': (60 + r.net) + '%' }">
                            <span class="circle"><i class="icon fs-4" :class="[ r.icon, 'text-' + r.css ]"></i></span>
                            <span class="progress-value fs-5 b-600">Net: {{ r.net }}</span>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
    import { reactive, toRefs, computed } from "vue";
    import { appData, C } from "@/helpers/global";

    export default {
        name: "NetAverage",
        props: {
            modelValue: {
                default: 0
            },
        },
        emits: ["update:modelValue"],
        setup(props, ctx) {            
            const e = reactive({
                value: computed({
                    get() {
                        return props.modelValue;
                    },
                    set(value) {
                        ctx.emit("update:modelValue", value);
                    }
                }),
                list: [
                    { id: 1, name: "Türkçe", css: "turkish", icon: "icon-turkish-lesson", net: 10 },
                    { id: 2, name: "Sosyal Bilgileri", css: "social-studies", icon: "icon-social-science-lesson", net: 33.75 },
                    { id: 3, name: "Matematik", css: "math", icon: "icon-maths-lesson", net: 27.50 },
                    { id: 4, name: "Fen Bilimleri", css: "science", icon: "icon-chemistry-lesson", net: 9.25 },
                ],
            });
            return { ...toRefs(e) };
        }
    };
</script>